import { ScenarioStep, Steps } from '../state/interfaces'
import { emailAddress } from './common-steps'

export const emailAddressPageGo: ScenarioStep = {
  ...emailAddress,
  question: 'email-address-page-go_question',
  tip: 'email-address-page-go_tip',
  next: Steps.DONE,
  // metadata: { grandImage: Images.ALERT_3 },
}
